import { normalizeEventDetail } from '@/common/normalize'

export const normalizeEventList = (rawData) => {
  if (!rawData) {
    return {}
  }
  return {
    list: rawData?.list.map((event) => normalizeEventDetail(event)) || [],
    count: rawData?.count || 0,
    pageCount: rawData?.pagecount,
    isNextPageGroup: rawData?.isnextpagegroup,
  }
}
